import { RequestResponsePattern } from "../../../../../types/Request"
import { getApi } from "../../../../../utils/requestApi"
import { DOMAIN } from "../../../../../var_env."
import { setProtocolos, setRequestGetData, setRequestGetLoading } from "../Reducers/ProtocoloReducer"
import { IAgrupamentoProtocolo } from "../Types/IProtocolo"


export default async function getProtocolos(dispatch: Function, obj: any) {
    try {
        dispatch(setRequestGetLoading())
        let str = ''
        for (let arr of Object.entries(obj)) str += `${arr[0]}=${arr[1] ?? ''}&`


        const query = str
        const endpoint = DOMAIN
        const params = `/protocolo/getAll?${query}`
        const response: RequestResponsePattern<IAgrupamentoProtocolo[]> = await getApi({ endpoint, params })

        if (response) {
            dispatch(setRequestGetData(response))
            if (!response.flagErro) {
                dispatch(setProtocolos(response.listaResultados))

            } else throw new Error(response.listaMensagens[0])
        } else throw new Error('Erro na requisição')
    } catch (error: any) {
        console.log(error)

    }
}